import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { LoginPage } from '@/features/auth/components/LoginPage';

interface LoginSearch {
  redirect?: string | undefined;
}

export const Route = createFileRoute('/_public/login')({
  validateSearch: (search: Record<string, unknown>): LoginSearch => ({
    redirect: typeof search.redirect === 'string' ? search.redirect : undefined,
  }),
  component: () => (
    <ErrorBoundary moduleName="Login">
      <Suspense fallback={<PageLoader />}>
        <LoginPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
